import React from 'react';

var AppSwitcherFooter = function AppSwitcherFooter(_ref) {
  var onLinkClick = _ref.onLinkClick;
  return /*#__PURE__*/React.createElement("div", {
    className: "app-switcher-footer"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://solarwinds.cloud",
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: onLinkClick
  }, "Read more about the SolarWinds Application Management Suite"));
};

export default AppSwitcherFooter;